<template>
  <div>
    <span>
      <button style="border: none; background: none; margin-right: 5px">
<feather-icon
                    icon="CheckIcon"
                    class="cursor-pointer"
                    svgClasses="w-8 h-8"
                    style="color: #28c76f"
                  />
      </button>
    </span>
  </div>
</template>
<script>
export default {
  methods: {},
};
</script>